var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "keep-alive",
    [
      _c(
        _vm.component,
        _vm._g(
          _vm._b(
            {
              tag: "component",
              staticClass: "modal-content",
              on: {
                input: function ($event) {
                  return _vm.$emit("input", $event)
                },
                "source-type": function ($event) {
                  return _vm.$emit("source-type", $event)
                },
                "attestation-check": function ($event) {
                  return _vm.$emit("attestation-check", $event)
                },
              },
            },
            "component",
            _vm.componentProps[true],
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }